import { render, staticRenderFns } from "./cancel-form.vue?vue&type=template&id=2ff85071&"
import script from "./cancel-form.vue?vue&type=script&lang=js&"
export * from "./cancel-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports